const currencies = {
  "aed": "AED",
  "aud": "AUD",
  "azn": "AZN",
  "cad": "CAD",
  "chf": "CHF",
  "eur": "EUR",
  "gbp": "GBP",
  "inr": "INR",
  "lkr": "LKR",
  "pln": "PLN",
  "qar": "QAR",
  "rsd": "RSD",
  "sgd": "SGD",
  "tl": "TL",
  "usd": "USD",
  "zar": "ZAR",
  "idr": "IDR",
  "omr": "OMR",
  "egp": "EGP",
  "irr": "IRR",
  "rm" : "RM",
  "nok": "NOK",
  "czk": "CZK",  
  "cfa": "CFA",
  "mad": "MAD",
  "sar": "SAR",
  "mxn": "MXN",
  "dkk":"DKK",
  "ron":"RON",
}

const countries = {
  "argentina": "Argentina",
  "australia": "Australia",
  "austria": "Austria",
  "azerbaijan": "Azerbaijan",
  "bahrain": "Bahrain",
  "bangladesh": "Bangladesh",
  "belgium": "Belgium",
  "botswana":"Botswana",
  "brazil": "Brazil",
  "cameroon": "Cameroon",
  "canada": "Canada",
  "chile": "Chile",
  "costa_rica": "Costa Rica",
  "czech":"Czech",
  "denmark":"Denmark",
  "egypt": "Egypt",
  "finland": "Finland",
  "france": "France",
  "germany": "Germany",
  "greece": "Greece",
  "india": "India",
  "indonesia": "Indonesia",
  "iran": "IRAN",
  "iraq": "Iraq",
  "ireland": "Ireland",
  "italy": "Italy",
  "jordan": "Jordan",
  "kazakhstan": "Kazakhstan",
  "kenya": "Kenya",
  "ksa": "KSA",
  "kuwait": "Kuwait",
  "lebanon": "Lebanon",
  "malaysia": "Malaysia",
  "marocco": "Marocco",
  "mexico": "Mexico",
  "myanmar":"Myanmar",
  "netherlands": "Netherlands",
  "nicaragua": "Nicaragua",
  "nigeria": "Nigeria",
  "norway": "Norway",
  "not_defined": "not_defined",
  "oman": "Oman",
  "pakistan": "Pakistan",
  "panama": "Panama",
  "philippines": "Philippines",
  "poland": "Poland",
  "portugal": "Portugal",
  "qatar": "Qatar",
  "romania":"Romania",
  "serbia": "Serbia",
  "singapore": "Singapore",
  "slovenia": "Slovenia",
  "south_africa": "South Africa",
  "spain": "Spain",
  "sri_lanka": "Sri Lanka",
  "sudan": "Sudan",
  "switzerland": "Switzerland",
  "thailand": "Thailand",
  "tunisia": "Tunisia",
  "turkey": "Turkey",
  "united_arab_emirates": "UAE",
  "united_kingdom": "United Kingdom",
  "usa": "USA",
  "vietnam": "Vietnam",
  "yemen": "Yemen"
};
/*
---Add operator in main mobitrans db at dbo.ZendeskOperators
------------------------------------------------------------
const operators = {
  "a1": "A1",
  "aircel": "AIRCEL",
  "airtel": "Airtel",
  "ais": "AIS",
  "ais_gsm": "AIS-GSM",
  "alfa": "Alfa",
  "asiacell": "Asiacell",
  "avea": "Avea",
  "azercell": "Azercell",
  "azerfon": "Azerfon",
  "bakcell": "Bakcell",
  "batelco": "Batelco",
  "batl": "BATL",
  "bouygues_highconnexion": "Bouygues-HighConnexion",
  "celcom": "Celcom",
  "claro": "claro",
  "dialog": "Dialog",
  "dialog_simato": "Dialog-Simato",
  "dtac": "DTAC",
  "du": "Du",
  "du_infomedia": "Du-Infomedia",
  "ee": "EE",
  "entel": "Entel",
  "etisalat": "Etisalat",
  "etisalat_infomedia": "Etisalat-Infomedia",
  "globe": "Globe",
  "h3g": "H3G",
  "hutch": "Hutch",
  "hutch_simato": "Hutch-Simato",
  "idea": "IDEA",
  "kolbi": "Kolbi",
  "korek": "Korek",
  "kpn": "KPN",
  "m1": "M1",
  "mci": "MCI",
  "mobilink": "Mobilink",
  "mobinil": "Mobinil",
  "mobitel": "Mobitel",
  "movistar": "Movistar",
  "mtn": "MTN",
  "mts": "MTS",
  "nawras": "Nawras",
  "operator_not_defined": "not_defined",
  "o2": "O2",
  "oman_mobile": "Oman Mobile",
  "ooredoo": "Ooredoo",
  "ooredoo_wataniya": "Ooredoo/Wataniya",
  "optus": "Optus",
  "optus_dt": "Optus-DT",
  "orange": "Orange",
  "orange_highconnexion": "Orange-HighConnexion",
  "plus": "Plus",
  "proximus": "Proximus",
  "qtel": "QTEL",
  "sat": "SAT",
  "sfr_highconnexion": "SFR-HighConnexion",
  "singtel": "Singtel",
  "smart": "Smart",
  "sonera": "Sonera",
  "sprint": "Sprint",
  "starhub": "StarHub",
  "sunrise": "Sunrise",
  "swisscom": "Swisscom",
  "t_mobile": "T-Mobile",
  "telcel": "Telcel",
  "tele2": "Tele2",
  "telenor": "Telenor",
  "telstra": "Telstra",
  "telstra_dt": "Telstra-DT",
  "telus": "Telus",
  "tim": "TIM",
  "touch": "Touch",
  "truemove": "Turkcell",
  "turkcell_direct": "Turkcell-Direct",
  "viva": "Viva",
  "vodacom": "Vodacom",
  "vodafone": "Vodafone",
  "wataniya": "Wataniya",
  "wind": "Wind",
  "xl": "XL",
  "zain": "Zain",
  "telenor-strex":"Telenor-Strex"
};
*/

const refundMethods = {
  "api": "API",
  "bank_transfer": "Bank Transfer",
  "operator_app": "Operator App",
  "paypal": "PayPal",
  "topup": "TopUp",
  "cheque": "Cheque",
  "western_union": "Western Union",
  "bill_payment": "Bill Payment",
  "operator_tool": "Operator Tool",
  "pending_information": "Pending Information",
  "to_be_defined": "To be defined"
};

const entityToRefundMethod = {
  "Pulse Digital B.V": {
    "bank_transfer": ["iban", "swift", "name", "email"],
    "paypal": ["name", "paypalID"],
    "pending_information": [],
    "bill_payment": ["accountNo", "lastName"],
    "api": []
  },
  "MBT USA": {
    "bank_transfer": ["accountNo", "routingCode", "name", "city", "email"],
    "paypal": ["paypalID", "name"],
    "pending_information": [],
    "bill_payment": ["accountNo", "lastName"],
    "api": []
  },
  "ADXS World Wide B.V.": {
    "bank_transfer": ["accountNo", "routingCode", "name", "city", "email"],
    "paypal": ["paypalID", "name"],
    "pending_information": [],
    "bill_payment": ["accountNo", "lastName"],
    "api": []
  },
  "MT Digital South Africa": {
    "bank_transfer": ["accountNo", "branch", "name", "email"],
    "paypal": ["name", "paypalID"],
    "topup": [],
    "pending_information": [],
  },
  "Nextgen Mobile PTE LTD": {
    "bank_transfer": ["accountNo", "bankName", "name", "email"],
    "paypal": ["name", "paypalID"],
    "pending_information": [],
    "api": []
  },
  "FF MOBILE BILISIM LIMITED SIRKETI": {
    "bank_transfer": ["iban", "name", "email"],
    "paypal": ["name", "paypalID"],
    "bill_payment": ["accountNo", "lastName"],
    "pending_information": [],
  },
  "Mobile Link B.V.": {
    "bank_transfer": ["name", "iban", "swift", "email"],
    "paypal": ["name", "paypalID"],
    "pending_information": [],
    "api": [],
    "bill_payment": ["accountNo", "lastName"]
  },
  "Bright Mobile B.V.": {
    "bank_transfer": ["name", "iban", "city", "swift", "email"],
    "paypal": ["name", "paypalID"],
    "bill_payment": ["accountNo", "lastName"],
    "api": [],
    "pending_information": [],
    "to_be_defined": [],
    "topup": []
  },
  "Mobitrans FZ LLC": {
    "bill_payment": ["accountNo", "lastName"],
    "bank_transfer": ["iban", "swift", "name", "email"],
    "paypal": ["name", "paypalID"],
    "topup": [],
    "pending_information": [],
    "api": []
  },
  "Moxi Charges Limited": {
    "api": []
  },
  "Antelaria Limited": {
    "api": []
  },
  "DexenPoll Limited": {
    "bank_transfer": ["iban", "swift", "name", "email"],
    "paypal": ["name", "paypalID"],
    "api": []
  },
};

const bankDetails = {
  "iban": "IBAN",
  "swift": "Swift",
  "name": "Name",
  "paypalID": "Paypal ID",
  "accountNo": "Account Number",
  "routingCode": "Routing Code",
  "city": "City",
  "branch": "Branch",
  bankName: "Bank Name",
  lastName: "Last Name",
  email: "Email"
}

const entityToRefundMethodRender = {
  "Pulse Digital B.V": {
    "bank_transfer": [
      {key: "iban", label: "IBAN"},
      {key: "swift", label: "Swift"},
      {key: "name", label: "Name"},
      {key: "email", label: "Email"},
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "pending_information": [],
    "bill_payment": [
      {key: "accountNo", label: "Account Number"},
      {key: "lastName", label: "Last Name"}
    ],
    "api": []
  },
  "MBT USA": {
    "bank_transfer": [
      {key: "accountNo", label: "Account Number"},
      {key: "routingCode", label: "Routing Code"},
      {key: "name", label: "Name"},
      {key: "city", label: "City"},
      {key: "email", label: "Email"},
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "pending_information": [],
    "bill_payment": [
      {key: "accountNo", label: "Account Number"},
      {key: "lastName", label: "Last Name"}
    ],
    "api": []
  },
  "ADXS World Wide B.V.": {
    "bank_transfer": [
      {key: "accountNo", label: "Account Number"},
      {key: "routingCode", label: "Routing Code"},
      {key: "name", label: "Name"},
      {key: "city", label: "City"},
      {key: "email", label: "Email"},
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "pending_information": [],
    "bill_payment": [
      {key: "accountNo", label: "Account Number"},
      {key: "lastName", label: "Last Name"}
    ],
    "api": []
  },
  "MT Digital South Africa": {
    "bank_transfer": [
      {key: "accountNo", label: "Account Number"},
      {key: "branch", label: "Bank Branch"},
      {key: "name", label: "Name"},
      {key: "email", label: "Email"}
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "pending_information": [],
    "topup": []
  },
  "Nextgen Mobile PTE LTD": {
    "bank_transfer": [
      {key: "accountNo", label: "Account Number"},
      {key: "bankName", label: "Bank Name"},
      {key: "name", label: "Name"},
      {key: "email", label: "Email"}
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "pending_information": [],
    "api": []
  },
  "FF MOBILE BILISIM LIMITED SIRKETI": {
    "bank_transfer": [
      {key: "iban", label: "IBAN"},
      {key: "name", label: "Name"},
      {key: "email", label: "Email"}
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "bill_payment": [
      {key: "accountNo", label: "Account Number"},
      {key: "lastName", label: "Last Name"}
    ],
    "pending_information": [],
  },
  "Mobile Link B.V.": {
    "bank_transfer": [
      {key: "iban", label: "IBAN"},
      {key: "swift", label: "Swift"},
      {key: "name", label: "Name"},
      {key: "email", label: "Email"}
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "pending_information": [],
    "api": [],
    "bill_payment": [
      {key: "accountNo", label: "Account Number"},
      {key: "lastName", label: "Last Name"}
    ]
  },
  "Bright Mobile B.V.": {
    "bank_transfer": [
      {key: "iban", label: "IBAN"},
      {key: "swift", label: "Swift"},
      {key: "name", label: "Name"},
      {key: "city", label: "City"},
      {key: "email", label: "Email"}
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "bill_payment": [
      {key: "accountNo", label: "Account Number"},
      {key: "lastName", label: "Last Name"}
    ],
    "api": [],
    "pending_information": [],
    "to_be_defined": [],
    "topup": []
  },
  "Mobitrans FZ LLC": {
    "bill_payment": [
      {key: "accountNo", label: "Account Number"},
      {key: "lastName", label: "Last Name"}
    ],
    "bank_transfer": [
      {key: "iban", label: "IBAN"},
      {key: "swift", label: "Swift"},
      {key: "name", label: "Name"},
      {key: "email", label: "Email"},
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "api": [],
    "pending_information": [],
    "topup": []
  },
  "Moxi Charges Limited": {
    "api": []
  },
  "Antelaria Limited": {
    "api": []
  },
  "DexenPoll Limited": {
     "bank_transfer": [
      {key: "iban", label: "IBAN"},
      {key: "swift", label: "Swift"},
      {key: "name", label: "Name"},
      {key: "email", label: "Email"},
    ],
    "paypal": [
      {key: "name", label: "Name"},
      {key: "paypalID", label: "Paypal ID"},
    ],
    "api": []
  },
};

export default {
  countries,
  currencies,  
  refundMethods,
  entityToRefundMethod,
  entityToRefundMethodRender,
  bankDetails
}



// WEBPACK FOOTER //
// ./src/helpers/enums.js